import React from 'react';

// Utils
import {
  SCHEMA_TYPE_MULTI_ENUM,
  SCHEMA_TYPE_TEXT,
  SCHEMA_TYPE_SHORT_TEXT,
  SCHEMA_TYPE_YOUTUBE,
} from '../../util/types';
import {
  isFieldForCategory,
  pickCategoryFields,
  pickCustomFieldProps,
} from '../../util/fieldHelpers.js';

import SectionDetailsMaybe from './SectionDetailsMaybe';
import SectionMultiEnumMaybe from './SectionMultiEnumMaybe';
import SectionTextMaybe from './SectionTextMaybe';
import SectionYoutubeVideoMaybe from './SectionYoutubeVideoMaybe';

/**
 * Renders custom listing fields.
 * - SectionDetailsMaybe is used if schemaType is 'enum', 'long', or 'boolean'
 * - SectionMultiEnumMaybe is used if schemaType is 'multi-enum'
 * - SectionTextMaybe is used if schemaType is 'text'
 *
 * @param {*} props include publicData, metadata, listingFieldConfigs, categoryConfiguration
 * @returns React.Fragment containing aforementioned components
 */
const CustomListingFields = props => {
  const {
    publicData,
    metadata,
    listingFieldConfigs,
    categoryConfiguration,
    intl,
    sectionGroup = 'all',
    excludeFieldKeys = [],
  } = props;

  const { key: categoryPrefix, categories: listingCategoriesConfig } = categoryConfiguration;
  const categoriesObj = pickCategoryFields(publicData, categoryPrefix, 1, listingCategoriesConfig);
  const currentCategories = Object.values(categoriesObj);

  const isFieldForSelectedCategories = fieldConfig => {
    const isTargetCategory = isFieldForCategory(currentCategories, fieldConfig);
    return isTargetCategory;
  };
  const propsForCustomFields =
    pickCustomFieldProps(
      publicData,
      metadata,
      listingFieldConfigs,
      'listingType',
      isFieldForSelectedCategories
    ) || [];
  const filteredPropsForCustomFields =
    excludeFieldKeys.length > 0
      ? propsForCustomFields.filter(customFieldProps => !excludeFieldKeys.includes(customFieldProps.key))
      : propsForCustomFields;

  const shouldRenderTextFields = sectionGroup === 'all' || sectionGroup === 'text';
  const shouldRenderDetailFields = sectionGroup === 'all' || sectionGroup === 'details';

  return (
    <>
      {shouldRenderDetailFields ? (
        <SectionDetailsMaybe {...props} isFieldForCategory={isFieldForSelectedCategories} />
      ) : null}
      {filteredPropsForCustomFields.map(customFieldProps => {
        const { schemaType, key, ...fieldProps } = customFieldProps;

        if (schemaType === SCHEMA_TYPE_TEXT || schemaType === SCHEMA_TYPE_SHORT_TEXT) {
          return shouldRenderTextFields ? <SectionTextMaybe key={key} {...fieldProps} /> : null;
        }

        if (schemaType === SCHEMA_TYPE_MULTI_ENUM) {
          return shouldRenderDetailFields ? (
            <SectionMultiEnumMaybe
              key={key}
              {...fieldProps}
              listingType={publicData?.listingType}
              intl={intl}
            />
          ) : null;
        }

        if (schemaType === SCHEMA_TYPE_YOUTUBE) {
          return shouldRenderDetailFields ? (
            <SectionYoutubeVideoMaybe key={key} {...fieldProps} />
          ) : null;
        }

        return null;
      })}
    </>
  );
};

export default CustomListingFields;
